<script lang="ts">
  import { appStore } from "$app/store.svelte"

  interface Props {
    course_progress: CourseProgressType
  }

  let { course_progress }: Props = $props()

  let step_content = course_progress.step_data.content
</script>

{#if step_content == "introduction"}
  <div class="px-12">
    <p class="text-center text-3xl text-bold">Welcome!</p>

    <p class="mt-6 text-lg">
      Congratulations on starting the <b
        >Hiring, Onboarding and Learning Course</b
      >
      which distills Marc Koehler's 30+ years as an Officer in the US Nuclear Submarine
      and Turnaround CEO, coaching and mentoring thousands of leaders and employees
      to reach their greatest potential.
    </p>
    <p class="mt-6 text-lg">
      This 9-Part Course teaches you the systems you need to put in place to
      hire and onboard the right people into your culture and then develop
      everyone daily. Includes four checklists for hiring and onboarding
      employees.
    </p>
    <p class="mt-6 text-lg">
      Just follow the step-by-step approach outlined in this online course to
      access all of the valuable videos and resources provided.
    </p>

    <p class="mt-6 text-lg font-bold">You can do this!</p>
  </div>

  <div class="px-12 my-12 w-full">
    <div class="relative" style="padding-top: 56.25%">
      <iframe
        src="https://player.vimeo.com/video/881887573"
        class="absolute inset-0 w-full h-full"
        allow="autoplay; fullscreen; picture-in-picture"
        allowfullscreen
        style="position:absolute;top:0;left:0;width:100%;height:100%;"
        title="E6 Course"
      ></iframe>
    </div>
  </div>
{:else if step_content == "wrap_up"}
  <div class="px-12">
    <p class="text-center text-3xl text-bold">
      Congratulations on completing the Hiring, Onboarding and Learning Course!
    </p>
  </div>

  <div class="px-12 my-12 w-full">
    <div class="relative" style="padding-top: 56.25%">
      <iframe
        src="https://player.vimeo.com/video/881888241"
        class="absolute inset-0 w-full h-full"
        allow="autoplay; fullscreen; picture-in-picture"
        allowfullscreen
        style="position:absolute;top:0;left:0;width:100%;height:100%;"
        title="E6 Course"
      ></iframe>
    </div>
  </div>

  <div class="mx-auto w-full flex justify-center my-8">
    <a
      href="/plans/{appStore.plan.id}/courses"
      class="btn btn-rounded success btn-big">VIEW COURSE LIBRARY</a
    >
  </div>
{/if}
